/** Document type kinds */
export enum DocumentTypeKindEnum {
  /** Income document */
  INCOME = 'INCOME',
  /** Expense document */
  EXPENSE = 'EXPENSE',
}
